import React, { useRef, useState } from "react";
import {
  Drawer,
  Divider,
  Button,
  Tag,
  Space,
  Descriptions,
  Typography,
  Badge,
  Modal,
  Row,
  Col,
  Avatar,
} from "antd";
import moment from "moment"; // Import moment
import {
  BUSINESS_SEGMENT_IMG,
  capitalizeWords,
  CURRENCY,
  getBookingType,
  getPayTypeLabel,
  getRoomTypeLabel,
  getSegmentLabel,
  PROJECT_NAME,
} from "../../constants/constent";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { HomeOutlined, PrinterOutlined } from "@ant-design/icons";
import LS_SERVICE from "../../utils/localStorage";
import assets from "../../utils/ImagesPath";
import { IMAGE_BASE_URL } from "../../constants/api";
const { Title, Text } = Typography;

const BookingDetailDrawer = ({ open, onClose, booking }) => {
  const {
    customer_name,
    order_id,
    // room,
    room_no,
    room_type,
    room_price,
    user,
    // total_amount,
    advance_amount,
    total_days,
    checkin_date,
    checkout_date,
    booking_status,
    closing_date,
    payment_method,
    payment_status,
    bill_amount,
    total_with_gst,
    order_amount,
    ex_service_amount,
    booking_segment,
    booking_source,
    booking_referred_name,
    tnx,
    orders,
  } = booking;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const { company_name } = LS_SERVICE.get("setting") || {};

  const { extra_services } = booking;

  // **Filter orders where o_tnx.status is "Pending"**
  const pendingOrders = orders.filter(
    (order) => order.o_tnx.status === "Pending",
  );

  const successOrders = orders.filter(
    (order) => order.o_tnx.status === "Successful",
  );

  const totalSOrderBill = successOrders
    .reduce((total, order) => total + parseFloat(order.total), 0)
    .toFixed(2);

  // **Sum up the full bill details for pending orders**
  // const totalOrderSubtotal = pendingOrders
  //   .reduce((total, order) => total + parseFloat(order.subtotal), 0)
  //   .toFixed(2);
  // const totalOrderDiscount = pendingOrders
  //   .reduce((total, order) => total + parseFloat(order.discount), 0)
  //   .toFixed(2);
  // const totalOrderTax = pendingOrders
  //   .reduce((total, order) => total + parseFloat(order.tax), 0)
  //   .toFixed(2);
  const totalOrderBill = pendingOrders
    .reduce((total, order) => total + parseFloat(order.total), 0)
    .toFixed(2);

  const bookingStatusTag = (
    <Tag
      color={
        booking_status === "0"
          ? "yellow"
          : booking_status === "1"
            ? "green"
            : booking_status === "2"
              ? "blue"
              : "red"
      }
    >
      {booking_status === "0"
        ? "Pending"
        : booking_status === "1"
          ? "OnGoing"
          : booking_status === "2"
            ? "Completed"
            : booking_status === "3"
              ? "Canceled"
              : booking_status === "4"
                ? "Accepted"
                : "Unknown"}
    </Tag>
  );

  // Format dates using moment
  const formattedCheckinDate = moment(checkin_date).format("MMMM Do, YYYY");
  const formattedCheckoutDate = moment(checkout_date).format("MMMM Do, YYYY");
  const formattedClosingDate = closing_date
    ? moment(closing_date).format("MMMM Do, YYYY")
    : "-";

  const generateReceipt = (transaction) => {
    const receipt = {
      receiptNo: transaction.id,
      guestName: customer_name,
      bookingId: order_id,
      roomNumber: room_no,
      roomType: getRoomTypeLabel(room_type),
      checkInDate: formattedCheckinDate,
      checkOutDate: formattedCheckoutDate,
      advanceAmount: transaction.amount,
      totalAmount:
        parseFloat(total_with_gst) +
        parseFloat(order_amount ?? 0) +
        parseFloat(ex_service_amount ?? 0),
      paymentMethod: getPayTypeLabel(transaction.payment_method),
      notes: "Customer requested early check-in",
    };

    setReceiptData(receipt);
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setReceiptData(null);
  };

  const handlePrintReceipt = () => {
    html2canvas(document.getElementById("receipt-modal-content"), {
      useCORS: true,
      allowTaint: false,
      scale: 2,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const width = 210;
      const height = (canvas.height * width) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 10, width, height);
      window.open(pdf.output("bloburl"), "_blank");
    });
  };
  return (
    <>
      <Drawer
        width={640}
        placement="right"
        closable={false}
        onClose={onClose}
        open={open}
        footer={
          <Space direction="vertical" style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Title
                style={{
                  color:
                    payment_status === "1"
                      ? "green"
                      : payment_status === "0"
                        ? "red"
                        : "red",
                }}
                level={4}
              >
                {booking_status !== "2" ? (
                  <b>
                    Amount: {CURRENCY}{" "}
                    {`${parseInt(bill_amount)} remaining to pay`}
                  </b>
                ) : (
                  <b>
                    Total Bill: {CURRENCY}{" "}
                    {parseFloat(total_with_gst) +
                      parseFloat(order_amount ?? 0) +
                      parseFloat(ex_service_amount ?? 0)}
                  </b>
                )}
              </Title>
              <div>
                <Button onClick={onClose}>
                  <b>Close</b>
                </Button>
              </div>
            </div>
          </Space>
        }
      >
        <Badge.Ribbon
          text={
            payment_status === null || payment_status === "0"
              ? "Payment Pending"
              : payment_status === "1"
                ? "Payment Done"
                : payment_status === "2"
                  ? "Payment Fail"
                  : "Unknown"
          }
          color={
            payment_status === "1"
              ? "green"
              : payment_status === "0"
                ? "red"
                : "red"
          }
        >
          <Title
            level={5}
            style={{
              marginBottom: 24,
            }}
          >
            <b>Booking Details for {order_id}</b> (
            {booking_status === "0"
              ? "Pending"
              : booking_status === "1"
                ? "OnGoing"
                : booking_status === "2"
                  ? "Completed"
                  : booking_status === "3"
                    ? "Canceled"
                    : booking_status === "4"
                      ? "Accepted"
                      : "Unknown"}
            )
          </Title>
        </Badge.Ribbon>
        <Title level={5}>
          <b>User Information</b>
        </Title>
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Full Name">
            {customer_name}
          </Descriptions.Item>
          {user.phone && user.phone !== "null" && (
            <Descriptions.Item label="Phone">{user.phone}</Descriptions.Item>
          )}
          {user.email && user.email !== "null" && (
            <Descriptions.Item label="Email">
              {user.email || "-"}
            </Descriptions.Item>
          )}
          {user.address && user.address !== "null" && (
            <Descriptions.Item label="Address">
              {user.address || "-"}
            </Descriptions.Item>
          )}
          {user.country && user.country.name && (
            <Descriptions.Item label="Country">
              {user.country
                ? `${user.country.name} ${String.fromCodePoint(
                    ...user.country.emojiU
                      .split(" ")
                      .map((code) => parseInt(code.replace("U+", "0x"), 16)),
                  )} `
                : "-"}
            </Descriptions.Item>
          )}
          {user.state && user.state.name && (
            <Descriptions.Item label="State">
              {user.state ? user.state.name : "-"}
            </Descriptions.Item>
          )}
          {user.city && user.city.name && (
            <Descriptions.Item label="City">
              {user.city ? user.city.name : "-"}
            </Descriptions.Item>
          )}
        </Descriptions>

        <Divider />

        <Title level={5}>Room Information</Title>
        <Descriptions bordered column={1}>
          {/* <Descriptions.Item label="Room No">{room_no}</Descriptions.Item> */}
          <Descriptions.Item label="Room Type">
            {getRoomTypeLabel(room_type)}
          </Descriptions.Item>
          <Descriptions.Item label="Room Price">{room_price}</Descriptions.Item>
        </Descriptions>
        <Divider />
        <Title level={5}>Room Bill Information</Title>
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Total Day's">
            <b>{total_days}</b>
          </Descriptions.Item>
          <Descriptions.Item label="Total Amount">
            {total_with_gst}
          </Descriptions.Item>
        </Descriptions>
        <Divider />
        {extra_services?.map((service) => (
          <>
            <Title level={5}>Extra Service Information</Title>
            <Descriptions bordered column={1}>
              <Descriptions.Item label="Service">
                {service.name}
              </Descriptions.Item>
              <Descriptions.Item label="Service Price">
                {service.price}
              </Descriptions.Item>
              <Descriptions.Item label="Quantity">
                <b>{service.quantity}</b>
              </Descriptions.Item>
              <Descriptions.Item label="Total Amount">
                {service.total_amount}
              </Descriptions.Item>
            </Descriptions>
            <Divider />
          </>
        ))}
        {orders && orders.length > 0 && (
          <>
            <Title level={5}>Order Bill Information</Title>
            <Descriptions bordered column={1}>
              <Descriptions.Item label="Total Orders's">
                <b>{orders.length}</b>
              </Descriptions.Item>
              <Descriptions.Item label="Order's (Unpaid)">
                <b>{pendingOrders.length}</b>
              </Descriptions.Item>
              <Descriptions.Item label="Total Amount">
                <b>{parseInt(totalSOrderBill) + parseInt(totalOrderBill)}</b>
              </Descriptions.Item>
              <Descriptions.Item label="Total Paid Amount">
                <b>{totalSOrderBill}</b>
              </Descriptions.Item>
              <Descriptions.Item label="Rest Amount">
                <b>{totalOrderBill}</b>
              </Descriptions.Item>
            </Descriptions>
            <Divider />
          </>
        )}

        <Title level={5}>
          <b>Booking Dates</b>
        </Title>
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Check-in Date">
            {formattedCheckinDate}
          </Descriptions.Item>
          <Descriptions.Item label="Check-out Date">
            {formattedCheckoutDate}
          </Descriptions.Item>
        </Descriptions>

        <Divider />

        <Title level={5}>
          <b>Booking</b>
        </Title>
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Status">
            {bookingStatusTag}
          </Descriptions.Item>
          <Descriptions.Item label="Booking Segment">
            {capitalizeWords(
              getSegmentLabel(booking_segment) +
                " (" +
                booking_source.toUpperCase() +
                ") ",
            )}
            <img
              style={{ width: "25px" }}
              src={
                BUSINESS_SEGMENT_IMG[getBookingType(booking)] ||
                BUSINESS_SEGMENT_IMG.others
              }
              alt={booking_source}
            />
          </Descriptions.Item>
          {booking_referred_name && (
            <Descriptions.Item label="Referred By">
              {booking_referred_name}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="Advance AMT">
            {CURRENCY} {parseInt(advance_amount)}
          </Descriptions.Item>
          <Descriptions.Item label="Grand Total">
            {CURRENCY}{" "}
            {parseFloat(total_with_gst) +
              parseFloat(order_amount ?? 0) +
              parseFloat(ex_service_amount ?? 0)}
          </Descriptions.Item>
        </Descriptions>

        <Divider />
        <Title level={5}>
          <b>Transactions: {tnx.length}</b>
        </Title>
        {tnx.map((transaction, index) => (
          <>
            <Descriptions bordered column={1}>
              <Descriptions.Item label="Transaction ID">
                {transaction ? transaction.razorpay_payment_id || "-" : "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Amount">
                {transaction
                  ? transaction.amount +
                      ", " +
                      getPayTypeLabel(transaction.payment_method) +
                      " (" +
                      transaction.status +
                      ") " || "-"
                  : "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Transaction on">
                {transaction
                  ? moment(transaction.created_at).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Recipt">
                <Button
                  type="primary"
                  icon={<PrinterOutlined />}
                  onClick={() => generateReceipt(transaction)}
                  style={{ width: "100%", marginTop: "20px" }}
                >
                  <b>Print Recipt</b>
                </Button>
              </Descriptions.Item>
            </Descriptions>
            <br />
          </>
        ))}

        {booking_status === "2" && (
          <>
            <Divider />
            <Title level={5}>
              <b>Booking Complete</b>
            </Title>
            <Descriptions bordered column={1}>
              <Descriptions.Item label="Closing Date">
                {formattedClosingDate}
              </Descriptions.Item>
              <Descriptions.Item label="Payment Method">
                {getPayTypeLabel(payment_method) || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Payment Status">
                {payment_status === null || payment_status === "0"
                  ? "Payment Pending"
                  : payment_status === "1"
                    ? "Payment Done"
                    : payment_status === "2"
                      ? "Payment Fail"
                      : "Unknown" || "-"}
              </Descriptions.Item>
            </Descriptions>
          </>
        )}

        <Divider />
      </Drawer>
      <Modal
        visible={isModalVisible}
        onCancel={closeModal}
        footer={null}
        width={600}
      >
        <div
          id="receipt-modal-content"
          style={{
            fontFamily: "Arial, sans-serif",
            fontSize: "12px",
            padding: "20px",
            backgroundColor: "#ffffff",
            color: "#000000",
            lineHeight: 1.4,
            maxWidth: "540px",
            margin: "0 auto",
          }}
        >
          {/* Header with Logo/Icon and Title */}
          <Row
            justify="center"
            style={{ marginBottom: "10px", textAlign: "center" }}
          >
            <Col span={24}>
              <img
                src={
                  LS_SERVICE.get("setting")?.logo
                    ? `${IMAGE_BASE_URL}${LS_SERVICE.get("setting").logo}`
                    : assets.logo
                }
                alt="Logo"
                style={{
                  height: "50px",
                  marginBottom: "5px",
                  objectFit: "contain",
                }}
              />
              <Title level={4} style={{ margin: "5px 0 0 0" }}>
                {company_name || PROJECT_NAME}
              </Title>
              <Text type="secondary" style={{ fontSize: "13px" }}>
                Advance Payment Receipt
              </Text>
            </Col>
          </Row>

          {/* Receipt and Booking IDs */}
          <Row justify="space-between" style={{ marginBottom: "8px" }}>
            <Col>
              <Text strong>Receipt No:</Text>{" "}
              <Text>{receiptData?.receiptNo || "N/A"}</Text>
            </Col>
            <Col>
              <Text strong>Booking ID:</Text>{" "}
              <Text>{receiptData?.bookingId || "N/A"}</Text>
            </Col>
          </Row>

          <Divider style={{ margin: "10px 0" }} />

          {/* Guest & Room Info */}
          <Row style={{ marginBottom: "6px" }}>
            <Col span={12}>
              <Text strong>Guest Name:</Text>
              <br />
              <Text>{receiptData?.guestName}</Text>
            </Col>
            <Col span={12}>
              <Text strong>Room No / Type:</Text>
              <br />
              <Text>
                {receiptData?.roomNumber} / {receiptData?.roomType}
              </Text>
            </Col>
          </Row>

          <Row style={{ marginBottom: "6px" }}>
            <Col span={12}>
              <Text strong>Check-in:</Text>
              <br />
              <Text>{receiptData?.checkInDate}</Text>
            </Col>
            <Col span={12}>
              <Text strong>Check-out:</Text>
              <br />
              <Text>{receiptData?.checkOutDate}</Text>
            </Col>
          </Row>

          <Divider style={{ margin: "10px 0" }} />

          {/* Financial Breakdown */}
          <Row style={{ marginBottom: "6px" }}>
            <Col span={18}>
              <Text strong>Advance Amount Paid:</Text>
            </Col>
            <Col span={6} style={{ textAlign: "right" }}>
              <Text>
                {CURRENCY}
                {receiptData?.advanceAmount || 0}
              </Text>
            </Col>
          </Row>

          <Row style={{ marginBottom: "6px" }}>
            <Col span={18}>
              <Text strong>Total Booking Amount:</Text>
            </Col>
            <Col span={6} style={{ textAlign: "right" }}>
              <Text>
                {CURRENCY}
                {receiptData?.totalAmount || 0}
              </Text>
            </Col>
          </Row>

          <Row style={{ marginBottom: "6px" }}>
            <Col span={18}>
              <Text strong>Balance Remaining:</Text>
            </Col>
            <Col span={6} style={{ textAlign: "right" }}>
              <Text>
                {CURRENCY}
                {(receiptData?.totalAmount || 0) -
                  (receiptData?.advanceAmount || 0)}
              </Text>
            </Col>
          </Row>

          <Row style={{ marginBottom: "6px" }}>
            <Col span={18}>
              <Text strong>Payment Method:</Text>
            </Col>
            <Col span={6} style={{ textAlign: "right" }}>
              <Text>{receiptData?.paymentMethod}</Text>
            </Col>
          </Row>
          <Divider style={{ margin: "10px 0" }} />

          {/* Footer: Optional */}
          <Row justify="center">
            <Col>
              <Text type="secondary" style={{ fontSize: "10px" }}>
                Thank you for choosing {company_name || PROJECT_NAME}.
              </Text>
            </Col>
          </Row>
        </div>

        {/* Print Button */}
        <Button
          type="primary"
          icon={<PrinterOutlined />}
          onClick={handlePrintReceipt}
          style={{ width: "100%", marginTop: "10px" }}
        >
          Print Receipt
        </Button>
      </Modal>
    </>
  );
};

export default BookingDetailDrawer;
